import React, {PureComponent} from 'react';
import Table from '../../../components/Table';
import {Col, Row, Card, CardBody, ButtonGroup, ButtonToolbar} from 'reactstrap';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import * as TextManager from "../../../modules/languages/TextManager";
import {withStyles} from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import {eq_item_open_update_form} from '../../../redux/actions/EquipmentActions';
import EditEquipmentStoreItem from './EditEquipmentStoreItem'

const actionsStyles = theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing.unit * 2.5,
    },
});

class TablePaginationActions extends React.Component {
    handleFirstPageButtonClick = event => {
        this.props.onChangePage(event, 0);
    };

    handleBackButtonClick = event => {
        this.props.onChangePage(event, this.props.page - 1);
    };

    handleNextButtonClick = event => {
        this.props.onChangePage(event, this.props.page + 1);
    };

    handleLastPageButtonClick = event => {
        this.props.onChangePage(
            event,
            Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1),
        );
    };

    render() {
        const {classes, count, page, rowsPerPage, theme} = this.props;

        return (
            <div className={classes.root}>
                <IconButton
                    onClick={this.handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="First Page"
                >
                    {theme.direction === 'rtl' ? <LastPageIcon/> : <FirstPageIcon/>}
                </IconButton>
                <IconButton
                    onClick={this.handleBackButtonClick}
                    disabled={page === 0}
                    aria-label="Previous Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight/> : <KeyboardArrowLeft/>}
                </IconButton>
                <IconButton
                    onClick={this.handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Next Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft/> : <KeyboardArrowRight/>}
                </IconButton>
                <IconButton
                    onClick={this.handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Last Page"
                >
                    {theme.direction === 'rtl' ? <FirstPageIcon/> : <LastPageIcon/>}
                </IconButton>
            </div>
        );
    }
}

TablePaginationActions.propTypes = {
    classes: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    theme: PropTypes.object.isRequired,
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, {withTheme: true})(
    TablePaginationActions,
);


const CustomPagination = withStyles(theme => ({
    root: {
        float: 'left'
    },
    '@media screen and (max-width: 480px)': {
        root: {
            //backgroundColor: theme.palette.common.black,
            marginLeft: '-50px'
        }
    }

}))(TablePagination);


class EquipmentStoreTable extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            windowType: 0,
            deals: [],
            selectedID: '',
            saving: false,
            error: false,
            page: 0,
            rowsPerPage: 20,
            searchValue: ''
        };
    }

    editItem = (item) => {

        if(!this.props.managers) {
            if (item.serial === this.state.selectedID && this.state.windowType === 2) {
                this.setState({selectedID: 0, windowType: 0});
            } else {
                this.props.dispatch(eq_item_open_update_form(item));
                this.setState({selectedID: item.serial, windowType: 2, error: false});
            }
        }
    };

    getRow(item, index, isDelete) {

        return (

            <React.Fragment key={item.serial}>

                <tr key={item.serial} style={this.props.managers ? {} : {cursor: 'pointer'}} onClick={() => this.editItem(item)}>

                    <td>{item.count}</td>
                    <td>{item.text}</td>
                    <td>{item.name}</td>
                    <td>{item.serial}</td>

                </tr>

                {this.state.windowType === 2 && item.serial === this.state.selectedID &&
                <tr key={item.serial + 2000}>
                    <td colSpan="7">
                        <EditEquipmentStoreItem onClose={() => this.editItem(item)}/>
                    </td>
                </tr>
                }
            </React.Fragment>
        );
    }

    handleChangePage = (event, page) => {
        this.setState({page});
    };

    handleChangeRowsPerPage = event => {
        this.setState({rowsPerPage: event.target.value});
    };

    changeSearch = (e) => {
        this.setState({searchValue: e.target.value});
    };

    filterDataBySearch = record => {
        //console.log(record);
        if (this.state.searchValue === undefined || this.state.searchValue === null || this.state.searchValue === "") {
            return true;
        } else {
            let matchingRecords = Object.values(record ? record : {});

            let retVal = false;
            matchingRecords.forEach(mr => {
                // debugger;
                if (typeof mr === 'string') {
                    if (mr.toLowerCase().includes(this.state.searchValue.toLowerCase())) {
                        retVal = retVal || true;
                    }
                } else if (typeof mr === 'number') {
                    if (parseInt(this.state.searchValue) === mr) {
                        retVal = retVal || true;
                    }
                } else if (typeof mr === 'object') {
                    retVal = retVal || this.filterDataBySearch(mr);
                }
            });
            return retVal;
        }
    };

    render() {

        const {rowsPerPage, page} = this.state;

        let dataTable = [];

        if(this.props.data) {
            dataTable = this.props.data;
        }

        if (this.state.searchValue !== '') {
            dataTable = dataTable.filter(this.filterDataBySearch);
        }

        let rows = dataTable.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((prize, index, isDelete) =>
            this.getRow(prize, index, isDelete)
        );

        return (
            <Col md={12} xl={12} lg={12} xs={12}>
                <CardBody style={{paddingBottom: "0rem"}}>
                    <div style={{display: 'flex', height: '100%', justifyContent: 'flex-end'}}>
                        <ButtonToolbar className='custom_dashboard_header_panel'>
                            <form className='topbar__search material-form'>
                                <div
                                    className='search_field_form_control material-form__field topbar__search-field'>
                                    <div className='search_field_root search_field_custom-underline'
                                         style={{border: 'groove'}}>
                                        <input className='search_field_custom-input' dir="rtl"
                                               placeholder={TextManager.getCurrentTextResource().Text.searchByNameOrID}
                                               value={this.state.searchValue}
                                               onChange={(e) => this.changeSearch(e)}/>
                                    </div>
                                </div>
                            </form>
                        </ButtonToolbar>
                    </div>
                </CardBody>
                <Card>

                    <CardBody>

                        <span>
                            <Table responsive className='table-hover table--bordered'>
                                <thead>
                                    <tr>

                                        <th>כמות</th>
                                        <th>תיאור</th>
                                        <th>שם ציוד</th>
                                        <th>מק"ט</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {rows}
                                </tbody>
                            </Table>
                            <Row>
                                <Col md={6} sm={12} lg={6} xs={12}>
                                    <CustomPagination
                                        labelRowsPerPage='' //{TextManager.getCurrentTextResource().Utils.rowsPerPage}
                                        rowsPerPageOptions={[5, 10, 20, 50, 100, 200]}
                                        component="div"
                                        count={this.props.data.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        backIconButtonProps={{
                                            'aria-label': 'Previous Page',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'Next Page',
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        ActionsComponent={TablePaginationActionsWrapped}
                                    />
                                </Col>
                                <Col md={6} sm={12} lg={6} xs={12}>
                                    <ButtonGroup className='btn-group--icons'
                                                 style={{marginTop: "10px", float: "right"}}>
                                        {/*<Button outline color='primary'
                                                onClick={this.handleDownload}>{TextManager.getCurrentTextResource().Utils.download}</Button>*/}
                                        {/*<Button outline color='primary'
                                                onClick={() => this.props.back()}>Go Back</Button>*/}
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </span>

                    </CardBody>
                </Card>
            </Col>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        //data: state.equipment.data.equipStore,
        status: state.equipment.status,
        utilsData: state.utilsData,
        userData: state.userData
    };
};

export default withRouter(connect(mapStateToProps)(EquipmentStoreTable))